import type {
    GenericVuetifyListItem
} from 'x1-base/types';
import { startCase as lo_startCase } from 'es-toolkit';

export interface EnumToGenericListOptions {
    caseTitle?: boolean;
};

export function useListUtils() {

    function enumToGenericList(
        enumObj: Record<string, string>,
        opts: EnumToGenericListOptions = {},
        omitByKey: string[] = []
    ): GenericVuetifyListItem[] {
        const list: GenericVuetifyListItem[] = [];

        for (const key in enumObj) {
            if (omitByKey.includes(key)) {
                continue;
            }

            const title = opts?.caseTitle ? lo_startCase(key) : key;
            const value = enumObj[key];

            list.push({
                title,
                value
            });
        }

        return list;
    }

    function getYesNoList(stringify = false): GenericVuetifyListItem[] {
        return ['Yes', 'No'].map((title: string, idx: number) => {
            const v = !Boolean(idx);
            return {
                title,
                value: stringify ? `${v}` : v
            };
        });
    }

    return {
        enumToGenericList,
        getYesNoList
    };
}
